/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.8.0",
  "gitBuildTime": "2026-10-05T18:07:35.896Z",
  "gitBuildVersion": "1.8.0",
  "gitCommitId": "50d27d5",
  "gitCommitIdFull": "50d27d5e5c36d7f6cfcf6edbca9e1d1babfc8318",
  "gitCommitTime": "2026-10-05T18:05:31.000Z",
  "version": "1.8.0-2026-10-05T18:05:31.000Z-(50d27d5)"
};
